import React from 'react'
import { bool } from 'prop-types'
import * as links from '../../constants/links'
import {
  FOOTER_LICENSE,
  SUPPORT,
  TERMS_OF_SERVICE,
  PRIVACY_POLICY,
  GOOGLE_API_SERVICES
} from '../../constants/ui.labels'
import { Color, Footer, Link } from '@cobalt/cobalt-react-components'

const TalkdeskFooter = ({ showGoogleFooterLink }) => (
  <Footer bgColor={Color.background.gray[100]}>
    <small>{FOOTER_LICENSE}</small>
    <Footer.Navigation>
      <Footer.Link>
        <Link target="_blank" href={links.SUPPORT}>
          {SUPPORT}
        </Link>
      </Footer.Link>
      <Footer.Link>
        <Link target="_blank" href={links.TERMS_OF_SERVICE}>
          {TERMS_OF_SERVICE}
        </Link>
      </Footer.Link>
      <Footer.Link>
        <Link target="_blank" href={links.PRIVACY_POLICY}>
          {PRIVACY_POLICY}
        </Link>
      </Footer.Link>
      {showGoogleFooterLink && (
        <Footer.Link>
          <Link target="_blank" href={links.GOOGLE_API_SERVICES}>
            {GOOGLE_API_SERVICES}
          </Link>
        </Footer.Link>
      )}
    </Footer.Navigation>
  </Footer>
)

TalkdeskFooter.propTypes = {
  showGoogleFooterLink: bool.isRequired
}

export default TalkdeskFooter
